import React, { useState } from 'react'
import { NavLink, Routes, Route, useMatch } from 'react-router-dom' // Updated imports for v6
import { useDispatch, useSelector } from 'react-redux'
import { useIdleTimer } from 'react-idle-timer'
import { Box, Hidden, IconButton } from '@mui/material'
import SearchForm from './components/SearchForm'
import FavoritesIndicator from './components/FavoritesIndicator'
import UserIcon from './components/UserIcon'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import { Container } from 'components'
import * as uiActions from 'modules/UI/actions'
import AuthPopup from 'modules/AuthPopup'
import { AuthPopupEnum } from 'utils/constants'
import { useIsMobile } from 'utils/UI'
import LogoSrc from 'components/Logo/Logo.png'
import LogoSmallSrc from 'components/Logo/LogoSmall.png'
import DropdownMenu from './components/DropdownMenu'
import api from 'utils/api'

const Header = () => {
  const [dropdownMenuAnchor, setDropdownMenuAnchor] = useState(null)
  const user = useSelector((state) => state.user)
  const showAuthPopup = useSelector((state) => state.ui.showAuthPopup)
  const match = useMatch('/') // Replaced useRouteMatch with useMatch
  const dispatch = useDispatch()
  const isMobile = useIsMobile()

  useIdleTimer({
    timeout: 1000 * 60 * 35,
    onActive: () => {
      api.post('/geo', user.location).catch(() => {})
    },
    debounce: 500
  })

  return (
    <header style={{ position: isMobile ? 'static' : 'fixed', width: '100%', top: 0, background: '#fff', zIndex: 1000 }}>
      <Container>
        <Box my={isMobile ? 1 : 3} display="flex" alignItems="center" justifyContent="space-between" height={48}>
          <Box display="flex" alignItems="center">
            {!match?.pattern?.end && ( 
              <Box mr={isMobile ? 0 : 4}>
                <NavLink to="/">
                  {isMobile ? (
                    <img src={LogoSmallSrc} height={50} alt="HiddenUnderGround logo" />
                  ) : (
                    <img src={LogoSrc} height={50} alt="HiddenUnderGround logo" />
                  )}
                </NavLink>
              </Box>
            )}
            <Hidden lgDown>
            <Routes>
              <Route path="/search" element={<SearchForm />} />
            </Routes>
            </Hidden>
          </Box>
          <Box display="flex" alignItems="center">
            {user.details ? (
              <>
                <FavoritesIndicator />
                <UserIcon
                  avatar={user.details.imageUrl}
                  name={user.details.firstName || user.details.email || 'a'}
                  handleClick={(e) => {
                    setDropdownMenuAnchor(e.currentTarget)
                  }}
                />
                <DropdownMenu
                  anchorElement={dropdownMenuAnchor}
                  onClose={() => setDropdownMenuAnchor(null)}
                />
              </>
            ) : (
              <Hidden mdUp>
                <IconButton onClick={() => dispatch(uiActions.showLogin(AuthPopupEnum.login))} size="large">
                  <AccountCircleIcon />
                </IconButton>
              </Hidden>
            )}
          </Box>
        </Box>
        <Hidden mdUp>
          <Box mt={3}>
          <Routes>
            <Route path="/search" element={<SearchForm full />} />
          </Routes>
          </Box>
        </Hidden>
      </Container>
      {!!showAuthPopup && <AuthPopup />}
    </header>
  )
}

export default Header
